import React, {useEffect, useState} from "react";
import classes from "../JoinQuizPage/ClassResult.module.css";
import {LatexInline} from "../../components/Tiptap/latexParser";
import { ReactComponent as CORRECT_ICON } from "../../images/grade-question-correct-icon.svg";
import { ReactComponent as ARROW_UP } from "../JoinQuizPage/images/arrow-up.svg";
import { ReactComponent as ARROW_DOWN } from "../JoinQuizPage/images/arrow-down.svg";

export default function ViewLiveRespMH({premise, premiseIdx, data, shouldShowCorrect, correctAnswers, isShared, notShowAnimation=false}) {
    const [isExpanded, setIsExpanded] = useState(false);

    const setBar = () => {
        let total = Object.values(data).reduce((result, item) => result + item, 0);
        Object.keys(data).forEach((option, index) => {
            let barWithPer = !total ? "0" : `${(data[option] / total) * 100}%`;
            let countBar = document.getElementById(`premise-${premiseIdx}-option-count-bar-${index}`);
            if (!!countBar) {
                countBar.style.width = barWithPer;
            }
        });
    }

    const resetBar = () => {
        Object.keys(data).forEach((option, index) => {
            let countBar = document.getElementById(`premise-${premiseIdx}-option-count-bar-${index}`);
            if (!!countBar) {
                countBar.style.width = "0";
            }
        });
    }


    useEffect(() => {
        if (isExpanded) {
            setBar();
        } else {
            resetBar();
        }
    }, [isExpanded, data]);

    return (
        <div className={classes.premiseChartContainer} style={{maxHeight: isExpanded ? Object.keys(data).length * 100 : 55}}>
            <span
                tabIndex={0}
                className={classes.premiseChartContainerHeader}
                onClick={() => setIsExpanded(!isExpanded)}
            >
                <span style={{
                    flex: 1,
                    minWidth: 0,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                }}>
                    <LatexInline>{premise}</LatexInline>
                </span>
                <span style={{flex: 1}}/>
                {isExpanded && <ARROW_UP/>}
                {!isExpanded && <ARROW_DOWN/>}
            </span>
            <div className={classes.premiseChartContainerBody} style={{paddingRight: 3, maxHeight: "unset"}}>
                {Object.keys(data).map((option, i) =>
                    <div key={i} className={classes.countBarContainer}>
                        <div id={`premise-${premiseIdx}-option-count-bar-${i}`} className={classes.countBar} style={{transition: notShowAnimation ? "none" : undefined}}/>
                        <span id={`premise-option-text-${i}`} style={{zIndex: 1}}>
                            <LatexInline>{option}</LatexInline>
                        </span>
                        <span style={{flex: 1}}/>

                        {!!shouldShowCorrect && correctAnswers[premiseIdx][1] === option &&
                            <span className={classes.correctBadge} style={{zIndex: 1}}><CORRECT_ICON/></span>
                        }

                        {isShared &&
                            <span className={classes.countBadge} style={{zIndex: 1}}>{data[option]}</span>
                        }
                    </div>
                )}
            </div>
        </div>
    );
}